import { faCog, faIdBadge, faPersonHarassing, faRecycle, faSitemap, faStar, faTag, faToolbox, faUserGroup, faWifi } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faBuildingShield, faCalendarCircleUser, faCalendarStar, faLandmark, faUserPolice } from '@fortawesome/pro-regular-svg-icons';
import { faCameraCctv, faNetworkWired, faTicket } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import collapsedLogo from '../../../assets/icon_access.png';
import logo from '../../../assets/logo_access.png';
import { translate } from '../../services/translate';
import LateralMenu from '../LateralMenu';

export default function AccessLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={[
                {
                    icon: faIdBadge,
                    text: translate('users'),
                    action: () => navigation.navigate('Access', { screen: 'Users' }),
                    selected: selectedMenu == 'users',
                    omit: !(authenticatedUser?.isAdmin
                        || authenticatedUser?.permissions?.access_edit_user_settings
                        || authenticatedUser?.permissions?.access_edit_user_acting_body_units
                        || authenticatedUser?.permissions?.access_edit_user_all_acting_bodies
                        || authenticatedUser?.permissions?.access_remove_user_acting_body
                        || authenticatedUser?.permissions?.access_remove_user_acting_body_unit
                        || authenticatedUser?.permissions?.access_remove_user_all_acting_bodies)
                },
                {
                    icon: faCalendarCircleUser,
                    text: translate('workSchedules'),
                    action: () => navigation.navigate('Access', { screen: 'WorkSchedules' }),
                    selected: selectedMenu == 'work-schedules',
                    omit: !(authenticatedUser?.permissions?.access_manage_work_schedules
                        || authenticatedUser?.permissions?.access_manage_all_acting_bodies_work_schedules)
                },
                {
                    icon: faTag,
                    text: translate('userTags'),
                    action: () => navigation.navigate('Access', { screen: 'UserTags' }),
                    selected: selectedMenu == 'user-tags',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_management_user_tags)
                },
                {
                    icon: faUserGroup,
                    text: translate('permissionLevels'),
                    action: () => navigation.navigate('Access', { screen: 'PermissionLevels' }),
                    selected: selectedMenu == 'permission-levels',
                    omit: !(authenticatedUser?.isAdmin
                        || authenticatedUser?.permissions?.access_edit_permission_level_settings
                        || authenticatedUser?.permissions?.access_edit_permission_level_settings_acting_body_unit
                        || authenticatedUser?.permissions?.access_edit_permission_level_settings_all_acting_bodies)
                },
                {
                    icon: faCameraCctv,
                    text: translate('groups'),
                    action: () => navigation.navigate('Access', { screen: 'Groups' }),
                    selected: selectedMenu == 'groups',
                    omit: !(authenticatedUser?.isAdmin
                        || authenticatedUser?.permissions?.access_edit_group_settings
                        || authenticatedUser?.permissions?.access_edit_group_settings_acting_body_unit
                        || authenticatedUser?.permissions?.access_edit_group_settings_all_acting_bodies)
                },
                {
                    icon: faLandmark,
                    text: translate('actingBodies'),
                    action: () => navigation.navigate('Access', { screen: 'ActingBodies' }),
                    selected: selectedMenu == 'acting-bodies',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_acting_body)
                },
                {
                    icon: faBuilding,
                    text: translate('actingBodyUnits'),
                    action: () => navigation.navigate('Access', { screen: 'ActingBodyUnits' }),
                    selected: selectedMenu == 'acting-body-units',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_acting_body)
                },
                {
                    icon: faBuildingShield,
                    text: translate('commands'),
                    action: () => navigation.navigate('Access', { screen: 'ActingBodyCommands' }),
                    selected: selectedMenu == 'acting-body-commands',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_acting_body)
                },
                {
                    icon: faUserPolice,
                    text: translate('roles'),
                    action: () => navigation.navigate('Access', { screen: 'Roles' }),
                    selected: selectedMenu == 'roles',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_acting_body)
                },
                {
                    icon: faToolbox,
                    text: translate('installationCompanies'),
                    action: () => navigation.navigate('Access', { screen: 'InstallationCompanies' }),
                    selected: selectedMenu == 'installation-companies',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_installation_company)
                },
                {
                    icon: faWifi,
                    text: translate('internetCompanies'),
                    action: () => navigation.navigate('Access', { screen: 'InternetCompanies' }),
                    selected: selectedMenu == 'internet-companies',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_internet_company)
                },
                {
                    icon: faSitemap,
                    text: translate('ptzPriority'),
                    action: () => navigation.navigate('Access', { screen: 'PtzPriority' }),
                    selected: selectedMenu == 'ptz-priority',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_ptz_priorities)
                },
                {
                    icon: faRecycle,
                    text: translate('turnstiles'),
                    action: () => navigation.navigate('Access', { screen: 'Turnstiles' }),
                    selected: selectedMenu == 'turnstiles',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_edit_turnstile)
                },
                {
                    icon: faCog,
                    text: translate('platformSettings'),
                    action: () => navigation.navigate('Access', { screen: 'PlatformSettings' }),
                    selected: selectedMenu == 'platform-settings',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_edit_platform_settings)
                },
                {
                    icon: faNetworkWired,
                    text: translate('allowedIps'),
                    action: () => navigation.navigate('Access', { screen: 'AllowedIps' }),
                    selected: selectedMenu == 'allowed-ips',
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions?.access_manage_allowed_ips)
                },
                {
                    icon: faPersonHarassing,
                    text: translate('abuseReports'),
                    action: () => navigation.navigate('Access', { screen: 'AbuseReports' }),
                    selected: selectedMenu == 'abuse-reports',
                    omit: !(authenticatedUser?.permissions?.access_see_abuse_reports || authenticatedUser?.permissions?.access_manage_abuse_reports)
                },
                {
                    icon: faCalendarStar,
                    text: translate('holidays'),
                    action: () => navigation.navigate('Access', { screen: 'Holidays' }),
                    selected: selectedMenu == 'holidays',
                    omit: !(authenticatedUser?.permissions?.access_manage_holidays)
                },
                {
                    icon: faStar,
                    text: translate('skills'),
                    action: () => navigation.navigate('Access', { screen: 'Skills' }),
                    selected: selectedMenu == 'skills',
                    omit: !(authenticatedUser?.permissions?.access_manage_skills || authenticatedUser?.permissions?.access_manage_all_acting_bodies_skills)
                },
                {
                    icon: faTicket,
                    text: translate('supportTickets'),
                    action: () => navigation.navigate('Access', { screen: 'SupportTickets' }),
                    selected: selectedMenu == 'support-tickets',
                    omit: !(authenticatedUser?.permissions?.manage_support_tickets)
                }
            ]}
        />
    );
}
